export default {
  title: "Design Masters",
  text: "Barcelona based Award-winning design studio Brosmind, is led by brothers Juan and Alejandro. Their work is admire and hired by international companies from all over the world: Nike, Adidas, Coca-Cola, Google, Ray-Ban, National Geographic, Landrover, Facebook, Honda, Mobile World Congress, Mailchimp, and many more.",
};
